import { Injectable, inject, signal } from '@angular/core';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { AdminApiService } from 'src/app/modules/admin/services/admin-api.service';

@Injectable({ providedIn: 'root' })
export class AdminAuthService {
  readonly #adminApi = inject(AdminApiService);
  readonly #isAdmin = signal(false);
  readonly #checked = signal(false);

  public readonly isAdmin = this.#isAdmin.asReadonly();

  /**
   * Calls /admin/me once; subsequent calls return the cached signal value.
   * Returns true if the current user has admin access, false otherwise.
   */
  public check(): Observable<boolean> {
    if (this.#checked()) {
      return of(this.#isAdmin());
    }
    return this.#adminApi.getMe().pipe(
      tap((user) => {
        this.#isAdmin.set(user.is_admin === true);
        this.#checked.set(true);
      }),
      map((user) => user.is_admin === true),
      catchError(() => {
        this.#checked.set(true);
        this.#isAdmin.set(false);
        return of(false);
      })
    );
  }
}
